module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/global-variables.json
// module id = 311
// module chunks = 117